import type { ElementType } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';

import rbacCheck from '@/rbac/rbacCheck';
import type { RootState } from '@/redux/types';

interface ProtectedRouteProps {
  permission: string;
  component: ElementType;
  getData?: ((userRoles: string[], organization: unknown) => unknown) | null;
}

export const ProtectedRoute = ({
  permission,
  component: Component,
  getData = null,
}: ProtectedRouteProps) => {
  const userRoles = useSelector((state: RootState) => state.user.roles);
  const organization = useSelector((state: RootState) => state.user.organization);

  if (!userRoles || userRoles.length === 0) {
    return <Navigate to='/404' />;
  }

  const checkData = getData ? getData(userRoles, organization) : organization;

  const hasPermission = rbacCheck(userRoles, permission, checkData);

  if (!hasPermission) {
    return <Navigate to='/404' />;
  }

  return <Component />;
};
